import axiosInstance from '@/services/axiosInstance'

async function deleteMetadatoInvoice (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return await new Promise((resolve, reject) => {
      resolve({ blnError: false })
    })
  } else {
    const req = {
      url: '/api/facturas/deletemetadatoinvoice',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { deleteMetadatoInvoice }
